module.exports = __webpack_public_path__ + "static/media/Why-Us-SmallImage.c466ebfe.jpg";